import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "dvc-cookie-notice-acknowledged";

const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // Slight delay to avoid layout jank on first paint
        const t = window.setTimeout(() => setVisible(true), 400);
        return () => window.clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const acknowledge = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie notice"
      data-embed-hide="true"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-[60] md:max-w-sm bg-background border border-border rounded-2xl shadow-soft p-5 md:p-6 animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <p className="text-[10px] tracking-[0.3em] uppercase text-accent font-medium mb-3">
        Cookies
      </p>
      <p className="text-xs md:text-sm text-foreground/85 font-light leading-relaxed">
        We use only essential cookies to operate this site securely. No tracking or advertising
        cookies are set. Read our{" "}
        <Link
          to="/privacy"
          className="underline underline-offset-2 hover:text-accent transition-colors"
        >
          Privacy Policy
        </Link>
        .
      </p>
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={acknowledge}
          className="px-5 py-2.5 bg-primary text-primary-foreground rounded-full text-[10px] uppercase tracking-[0.3em] hover:bg-accent transition-colors duration-500"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default CookieNotice;
